import React from 'react'

function Navbar() {
  return (
    <div>Navbar</div>
  )
}

export default Navbar;